import React from 'react';
import '../styles/Global.css';
import '../styles/Home.css';
import Header from './Header';
import Footer from './Footer';
import { homeServices } from './homeServicesData';
import FAQSection from './FAQSection';

// Social media icons
import facebookIcon from '../assets/socialmedia/facebook.svg';
import xIcon from '../assets/socialmedia/x.svg';
import youtubeIcon from '../assets/socialmedia/youtube.svg';
import instagramIcon from '../assets/socialmedia/instagram.svg';
import linkedinIcon from '../assets/socialmedia/linkedin.svg';

const socialLinks = [
    { icon: facebookIcon, label: 'Facebook', url: '#' },
    { icon: instagramIcon, label: 'Instagram', url: '#' },
    { icon: xIcon, label: 'X', url: '#' },
    { icon: youtubeIcon, label: 'YouTube', url: '#' },   
    { icon: linkedinIcon, label: 'LinkedIn', url: '#' }
];

const Home: React.FC = () => {
    // Click outside handler
    React.useEffect(() => {
        const handleClick = (e: MouseEvent) => {
            // Only reset if click is outside any .home-service-card
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    return (
        <div className="page-container">
            <div className="hero-bg-wrapper">
                <Header />
                <main className="page-content home-main">
                    {/* 1. Consphic Vision Section */}
                    <section className="hero-section">
                        <div className="hero-content">
                            <h1 className="hero-title">Our<br/>Expertise</h1>
                            <p className="hero-description">
                                We elevate your user experience with captivating design, craft intuitive and visually stunning solutions, drive business success through strategic creativity, transform brand connections with impactful aesthetics, and enhance social engagement with memorable designs, ensuring a seamless and delightful journey for your audience.                        
                            </p>
                            <button className="hero-btn">KNOW MORE</button>
                        </div>
                    </section>
                </main>
            </div>
            {/* 2. Services Section */}
            <section className="home-services-section custom-services-bg">
                <div className="services-header-row">
                    <h3 className="services-section-title">SERVICES</h3>
                    <span className="services-section-subtitle">we offer wide range of digital solutions</span>
                </div>
                <div className="services-grid">
                    {homeServices.map((service) => (
                        <div className="service-card" key={service.title}>
                            <div className="custom-service-img-wrapper">
                                <img src={service.img} alt={service.title} className="custom-service-img" />
                                <div className="custom-service-title-overlay">{service.title}</div>
                            </div>
                        </div>
                    ))}
                </div>                    
            </section>
            {/* 3. FAQ Section */}
            <FAQSection />
            {/* 4. Media Section */}
            <section className="home-media-section">
                <div className="media-header-group">
                    <div className="media-section-title">SOCIAL MEDIA</div>
                    <h2 className="media-title left-align">Follow us for more updates</h2>
                </div>
                <div className="media-social-links-grid">
                    {socialLinks.map((link, idx) => (
                        <div className="media-social-logo-col" key={link.label}>
                            <a href={link.url} className="media-social-link" target="_blank" rel="noopener noreferrer">
                                <img src={link.icon} alt={link.label} className="media-social-icon" />
                                <span>{link.label.toUpperCase()}</span>
                            </a>                           
                        </div>
                    ))}
                </div>
                 <div className="media-links-col" style={{ display: 'flex', flexDirection: 'row', gap: '4.5vw' }}>
                    <div className="media-links">
                        <div className="media-links-title white">Company</div>                                            
                        <a href="/about">Who we are</a>
                        <a href="/services">What we do</a>
                        <a href="/careers">Careers</a>
                        <a href="/contact">Contact Us</a>
                    </div>
                    <div className="media-links">
                        <div className="media-links-title white">What we do</div>
                        <a href="/services#web-development">Web Development</a>
                        <a href="/services#multimedia">Multimedia</a>
                        <a href="/services#consulting">SEO Services</a>
                        <a href="/services#smm">SMM Services</a>                
                    </div>
                </div>
            </section>
            <Footer />            
        </div>
    );
};

export default Home;